import * as React from "react";
import { PracticeDetails } from "./practice-management/Practice";
import PracticeDetailsEditableForm from "./practice-management/PracticeDetailsEditableForm";
import HeaderBar from "./commons/components/HeaderBar";
import Country from "./commons/model/address/Country";
import { createRoot } from "react-dom/client";

interface PracticeManagementViewerProps {
  practiceDetails: PracticeDetails;
  countries: Country[];
  apiUrl: string;
  googleApiKey: string;
}

export default function PracticeManagementViewer({
  practiceDetails,
  countries,
  apiUrl,
  googleApiKey,
}: PracticeManagementViewerProps) {
  return (
    <>
      <HeaderBar title={i18n["Page.PracticeManagement.Practice"]} />
      <div className="container">
        <PracticeDetailsEditableForm
          googleApiKey={googleApiKey}
          practiceDetails={practiceDetails}
          countries={countries}
          apiUrl={apiUrl}
        />
      </div>
    </>
  );
}

PracticeManagementViewer.loadComponent = (
  elementId: string,
  props: PracticeManagementViewerProps
) => {
  const container = document.getElementById(elementId);
  const root = createRoot(container!);
  root.render(<PracticeManagementViewer {...props} />);
};
